import React from 'react';

import formatNumber from 'helpers/formatNumber';

import {
  EntityCell,
  CellContent,
  ValueWrapper,
} from '../TableRow/TableRow.style';

import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import ChangeArrow from './ChangeArrow';
import { IMetric } from 'maps/metrics';

interface IBrowseTableCellProps {
  entityData: any;
  header: IMetric;
  newDesign?: boolean;
}

const BrowseTableCell: React.FC<IBrowseTableCellProps> = (props) => {
  const { entityData, header, newDesign } = props;

  const positionChangeKey = header.isRange ? header.key : null;

  const textValue = positionChangeKey
    ? formatNumber(entityData[positionChangeKey], 'trend', true)
    : formatNumber(entityData[header.key], 'number', true);
  const tooltipValue = positionChangeKey
    ? formatNumber(entityData[positionChangeKey], 'trend')
    : formatNumber(entityData[header.key]);

  const isPositive =
    positionChangeKey && textValue !== '–'
      ? entityData[positionChangeKey] > 0
      : null;

  return (
    <EntityCell
      key={`browse-data-cell-${header.key}`}
      data-cell-value={textValue}
    >
      <CellContent>
        <TippyToolTip tooltipContent={tooltipValue} enabled canBeCopied>
          <ValueWrapper newDesign={newDesign} isPositive={isPositive}>
            {positionChangeKey && !newDesign ? (
              <ChangeArrow
                changeValue={entityData[positionChangeKey]}
                textValue={textValue}
              ></ChangeArrow>
            ) : (
              textValue
            )}
          </ValueWrapper>
        </TippyToolTip>
      </CellContent>
    </EntityCell>
  );
};

export default BrowseTableCell;
